/**
 * _meta_pixel.js — the one loader for Meta's Pixel (fbevents.js).
 *
 * Imported by meta_pixel_controller.js (PageView on every page) and
 * ad_conversions_controller.js (conversion events). Whichever runs first
 * installs the fbq queue and injects the script; later calls reuse
 * window.fbq, so the Pixel is initialised once per full page load and
 * survives Turbo navigations.
 *
 * Automatic data collection stays off: the Pixel sends only the events
 * Chippie fires, and never scans page content or button text.
 *
 * Not a *_controller.js file, so esm/index.js does not register it as a
 * Stimulus controller.
 */

const META_PIXEL_SRC = "https://connect.facebook.net/en_US/fbevents.js";

export function metaPixel(pixelId) {
    if (!window.fbq) {
        const fbq = function () {
            fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
        };
        Object.assign(fbq, { push: fbq, loaded: true, version: "2.0", queue: [] });
        window.fbq = window._fbq = fbq;
        const script = document.createElement("script");
        script.async = true;
        script.src = META_PIXEL_SRC;
        document.head.appendChild(script);
        fbq("set", "autoConfig", false, pixelId);
        fbq("init", pixelId);
    }
    return window.fbq;
}
